<template>
  <el-dialog
    title="修改库存"
    :visible.sync="stockVisible"
    :close-on-click-modal="false"
    @close="onStockVisible"
    width="30%">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="发放数量" prop="quantity">
        <el-input v-model="form.quantity" placeholder="请输入发放数量">
          <template slot="append">张</template>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onStockVisible">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
export default {
  name: "changeStock",
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null || value == 0) {
        callback(new Error('请输入发放数量'));
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error('请输入正数'));
      } else if (Number(value) > 1000000) {
        callback(new Error('最多追加到100万张'));
      } else if(Number(value) <= this.quantityOld) {
        callback(new Error('最新库存数量应大于原始库存数量'+this.quantityOld));
      }else {
        callback();
      }
    };
    return {
      loading: false,
      stockVisible: false,
      quantityOld: '',
      row: {},
      form: {
        quantity: ''
      },
      rules:{
        quantity: [
          // { required: true, message: '请输入发放数量', trigger: 'blur' },
          {
            required: true,validator: validateQuantity, trigger: 'blur'
          },
        ],
      }
    };
  },
  methods: {
    async openStock(row) {
      console.log(row, "row===库存");
      this.row = row;
      this.stockVisible = true;
      const res = await MiniModel.zfbQueryQuantityBeforeAppend({
        appKey: localStorage.getItem("appKeyMini"),
        id: row.id
      })
      console.log(res, "res==1=zfbQueryQuantityBeforeAppend");
      if(res.data.code == 200) {
        this.form.quantity = res.data.data;
        this.quantityOld = res.data.data;
      }
    },

    onStockVisible() {
      this.stockVisible = false;
      this.$refs.form.resetFields();
    },
    submit() {
      debounce(()=> {
        this.$refs.form.validate(async(valid) => {
          console.log(this.form,'this.form====')
          if (valid) {
            console.log('提交的数据成功:', this.form);
            this.loading = true;
            // this.stockVisible = false;
            const res = await MiniModel.zfbActivityAppendCode({
              appKey: localStorage.getItem("appKeyMini"),
              id: this.row.id,
              quantity: this.form.quantity
            }).finally(() => {
              this.loading = false;
            });
            console.log(res, "res==1=getZfbActivityPage");
            if(res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.stockVisible = false;
              this.$emit('changeSrock');
            }else{
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          } else {
            console.log('表单验证失败!');
            return false;
          }
        });
      },1000,true)

      // this.$emit('change');
      // this.stockVisible = false;
    },
  }
};
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/couponGroup/component/changeStock.vue